import { jsxs as e, jsx as l } from "react/jsx-runtime";
const t = (a) => /* @__PURE__ */ e("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1rem", height: "1rem", fill: "none", viewBox: "0 0 32 24", ...a, children: [
  /* @__PURE__ */ l(
    "path",
    {
      fill: "#F0F0FF",
      stroke: "#D9D8FF",
      d: "M.5 3A2.5 2.5 0 0 1 3 .5h26A2.5 2.5 0 0 1 31.5 3v18a2.5 2.5 0 0 1-2.5 2.5H3A2.5 2.5 0 0 1 .5 21V3Z"
    }
  ),
  /* @__PURE__ */ l(
    "path",
    {
      fill: "#4945FF",
      fillRule: "evenodd",
      d: "M21.375 16.316c.417-.407.625-.904.625-1.492 0-.589-.206-1.089-.618-1.5l-1.53-1.53a2.042 2.042 0 0 0-1.5-.617 2.06 2.06 0 0 0-1.529.646l-.646-.646c.43-.422.646-.934.646-1.537a2.03 2.03 0 0 0-.61-1.493l-1.515-1.522a2.014 2.014 0 0 0-1.5-.625 2.03 2.03 0 0 0-1.492.61l-1.081 1.074A2.006 2.006 0 0 0 10 9.176c0 .589.206 1.089.618 1.5l1.53 1.53c.41.412.91.617 1.5.617a2.06 2.06 0 0 0 1.529-.646l.646.646a2.069 2.069 0 0 0-.646 1.537c0 .588.203 1.086.61 1.493l1.514 1.522c.407.417.907.625 1.5.625a2.03 2.03 0 0 0 1.493-.61l1.081-1.074Zm-5.956-6.678a.68.68 0 0 0-.205-.5l-1.515-1.522a.68.68 0 0 0-.5-.206.71.71 0 0 0-.5.199l-1.081 1.073a.672.672 0 0 0-.206.493.68.68 0 0 0 .206.5l1.53 1.53a.678.678 0 0 0 .5.198.71.71 0 0 0 .529-.228l-.14-.136a4.46 4.46 0 0 1-.158-.158 1.756 1.756 0 0 1-.11-.14.593.593 0 0 1-.122-.39.68.68 0 0 1 .206-.5.68.68 0 0 1 .5-.206.59.59 0 0 1 .39.121c.064.047.11.084.14.111.03.027.082.08.158.158l.136.14a.713.713 0 0 0 .242-.537Zm5.168 5.187a.68.68 0 0 0-.206-.5l-1.529-1.53a.68.68 0 0 0-.5-.205.7.7 0 0 0-.53.235l.14.136c.079.076.132.129.159.158.027.03.063.076.11.14a.591.591 0 0 1 .121.39.681.681 0 0 1-.206.5.681.681 0 0 1-.5.206.591.591 0 0 1-.39-.121 1.746 1.746 0 0 1-.14-.111 4.395 4.395 0 0 1-.157-.158 20.642 20.642 0 0 0-.136-.14.714.714 0 0 0-.037 1.037l1.515 1.522a.678.678 0 0 0 .5.198.708.708 0 0 0 .5-.19l1.08-1.074a.672.672 0 0 0 .206-.493Z",
      clipRule: "evenodd"
    }
  )
] }), c = t;
export {
  c as default
};
